import {
  DurationDiscount,
  PaymentBillingMode,
} from "../types/licence.definition";

/**
 * Last-resort rates, used only when GET /licences/duration-discounts fails.
 * The endpoint is the source of truth: it is built from the same function
 * medecine360-api bills with, including the one-year rates the admin sets on
 * the Tarification page.
 */
export const FALLBACK_DURATION_DISCOUNTS: DurationDiscount[] = [
  {
    contractDuration: "ONE_MONTH",
    paymentBillingMode: null,
    discountPercentage: 0,
  },
  {
    contractDuration: "ONE_YEAR",
    paymentBillingMode: null,
    discountPercentage: 10,
  },
  {
    contractDuration: "THREE_YEARS",
    paymentBillingMode: null,
    discountPercentage: 20,
  },
  {
    contractDuration: "FIVE_YEARS",
    paymentBillingMode: null,
    discountPercentage: 30,
  },
];

/**
 * The exact (duration, billing mode) entry, else the (duration, no mode) one,
 * else 0.
 */
export const findDiscountPercentage = (
  discounts: DurationDiscount[],
  contractDuration: string | null | undefined,
  paymentBillingMode: PaymentBillingMode | null = null
): number => {
  if (!contractDuration) return 0;
  const exact = discounts.find(
    d =>
      d.contractDuration === contractDuration &&
      d.paymentBillingMode === paymentBillingMode
  );
  if (exact) return exact.discountPercentage;
  const generic = discounts.find(
    d =>
      d.contractDuration === contractDuration && d.paymentBillingMode === null
  );
  return generic ? generic.discountPercentage : 0;
};

/**
 * Same rounding as the server: the discount is rounded to whole FCFA (half up)
 * and taken off the base.
 */
export const applyDurationDiscount = (
  base: number,
  percentage: number
): { discount: number; amount: number } => {
  const discount = Math.round((base * percentage) / 100);
  return { discount, amount: base - discount };
};
